import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of, tap, throwError } from 'rxjs';
import { CleanFilesStoreAction } from '@core/store/actions/files.action';
import { VisualEvent } from '@core/interfaces/visual-event';
import { AppState } from 'src/app/app.state';
import { VisualEventsService } from 'src/app/mobile/services/visual-events.service';

@Injectable({
  providedIn: 'root',
})
export class VisualEventGuidedService {
  readonly #visualEventsService = inject(VisualEventsService);
  readonly #store = inject(Store<AppState>);

  public unlinkImageFromVisualEvent(visualEvent: VisualEvent, fileId: string, taskId: string): Observable<void> {
    const removedImage = visualEvent.images.find(img => img.fileId === fileId);
    if (!removedImage) {
      return throwError(() => new Error(`Image with fileId ${fileId} not found in Visual Event`));
    }

    visualEvent.images = visualEvent.images.filter(img => img.fileId !== fileId);

    if (!visualEvent.eventId) {
      this.#store.dispatch(CleanFilesStoreAction());
      return of(undefined);
    }

    return this.#visualEventsService
      .updateVisualEvent(visualEvent.eventId, visualEvent, taskId)
      .pipe(tap(() => this.#store.dispatch(CleanFilesStoreAction())));
  }
}
